import { createSelector } from 'reselect';
import { IRootState } from '../../app/types/rootReducers.t';
import { MOBILE_HISTORY_INFO_TYPES } from '../../mobileAppCore/components/MobileHistory/mobileHistoryConstants';

const moduleSelector = (state: IRootState) => state.account;

export const getAccountPortfolio = createSelector(
    moduleSelector,
    state => state.portfolio
);

export const makeSelectTradingToken = () =>
    createSelector(
        moduleSelector,
        state => state.tradingToken,
    );
export const makeSelectTradingTokenGetting = () =>
    createSelector(
        moduleSelector,
        state => state.tradingTokenGetting,
    );

export const getCurrentBalanceSelector = createSelector(moduleSelector, state => state.portfolio?.balance ?? 0);

export const makeSelectCurrentEquity = () =>
    createSelector(
        moduleSelector,
        state => state.portfolio?.equity ?? 0,
    );

export const getTransactionHistory = createSelector(
    moduleSelector, state => state.transactionHistory,
);

export const makeSelectPayments = () =>
    createSelector(
        moduleSelector,
        state => state.payments,
    );

export const getSelectPayoutError = createSelector(
    moduleSelector,
    state => state.error,
);

export const getUserConfirmEmailLoading = createSelector(
    moduleSelector, state => state.confirmEmailLoading
);

export const getUserConfirmEmailRequestTime = createSelector(
    moduleSelector, state => state.confirmEmailRequestTime
);

export const getAccountSelectedHistoryInfo = createSelector(
    moduleSelector, state => state.selectedHistoryInfo,
);

export const getAccountSelectedTransactionInfo = createSelector(
    getAccountSelectedHistoryInfo, state => state[MOBILE_HISTORY_INFO_TYPES.TRANSACTION],
);

export const getAccountSelectedPositionInfo = createSelector(
    getAccountSelectedHistoryInfo, state => state[MOBILE_HISTORY_INFO_TYPES.POSITION],
);

export const getAccountHistory = createSelector(
    moduleSelector, state => state.history,
);

export const getRefillDemoLoading = createSelector(
    moduleSelector, state => state.refillDemoLoading
);
